<template>
    <div class="detail restricted-tab">
        <div class="row mx-auto detail__image">
            <div
                class="d-flex flex-column flex-md-row align-items-center w-100"
            >
              <div class="position-relative d-flex" style="cursor: pointer;border-radius: 50%;overflow: hidden" @click="selectImage">
                <user-avatar :avatarURL="company.logo_src" size="136"></user-avatar>
                <div class="avatar-edit">Edit</div>
              </div>
                <div
                    class="d-flex flex-column pl-md-2 ml-0 justify-content-center "
                >
                    <div class="company-name font-weight-bold">
                        {{ company.name || company.name }}
                    </div>
                    <div class="member-since d-md-block d-none">
                        Member Since
                        {{ dateText }}
                    </div>
                </div>
            </div>
        </div>
        <input
            type="file"
            ref="fileUpload"
            hidden
            accept="image/*"
            @change="uploadImage($event)"
        />
        <div class="row restricted-tab">
            <div class="col-12 col-md-6 mb-3">
                <div class="form-group">
                    <label for="company_name">Company Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="company_name"
                        v-model="company.name"
                    />
                </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <!-- total employees -->
                <div class="form-group">
                    <label for="totalEmployeesInput"
                        >How many employees does your company have?</label
                    >
                    <input
                        type="number"
                        min="1"
                        class="form-control"
                        id="totalEmployeesInput"
                        aria-describedby="emailHelp"
                        v-model="company.employee_count"
                    />
                </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <!-- city -->
                <div class="form-group">
                    <label for="cityInput">City</label>
                    <select
                        class="custom-select"
                        name="city"
                        id="cityInput"
                        v-model="company.city"
                    >
                        <option
                            v-for="(city, key) in cities"
                            :value="city"
                            :key="key"
                            v-text="city"
                        ></option>
                    </select>
                </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <!-- country -->
                <div class="form-group">
                    <label for="countryInput">Country</label>
                    <select
                        class="custom-select"
                        name="country"
                        id="countryInput"
                        v-model="company.country"
                    >
                        <option
                            v-for="(country, key) in countries"
                            :value="country"
                            :key="key"
                            v-text="country"
                        ></option>
                    </select>
                </div>
            </div>

            <div class="col-12 col-md-6 mb-3">
                <!-- total employees -->
                <!-- <div class="form-group">
                    <label for="companyImage">Upload company logo</label>
                    <input
                        type="file"
                        accept="image/*"
                        @change="uploadImage($event)"
                        class="form-control wfh-version"
                        id="companyImage"
                    />
                </div> -->
            </div>

            <div class="col-12 mb-3">
                <div class="w-100 d-flex justify-content-between">
                    <label>Office location and timezone(s)</label>
                    <button
                        class="wfh-link"
                        data-toggle="modal"
                        data-target="#addNewOffice"
                    >
                        <i class="fas fa-plus"></i> Add
                    </button>
                </div>

                <office-select :officeStore="officeStore" />
            </div>

            <office-select-modal :officeStore="officeStore" />

            <div class="col-12 mb-3">
                <div class="form-group">
                    <label>Do you allow employees to work from home?</label>
                    <br />
                    <div class="btn-group btn-group-toggle row">
                        <div
                            class="col-md-3 col-6"
                            v-for="(option,
                            value) in dropDownOptions.wfhOptions"
                            :key="value"
                        >
                            <label
                                class="btn radio-btn "
                                v-bind:class="{
                                    active: value === company.work_from_home
                                }"
                            >
                                <img
                                    v-if="company.work_from_home == value"
                                    v-bind:src="
                                        '/images/icon-checked-white.svg'
                                    "
                                    alt
                                />
                                <input
                                    type="radio"
                                    name="work_from_home"
                                    :id="value"
                                    :value="value"
                                    autocomplete="off"
                                    v-model="company.work_from_home"
                                />
                                <span class="radio-align">{{ option }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 mb-3">
                <div class="form-group">
                    <label>Do you allow employees to travel?</label>
                    <br />
                    <div class="btn-group btn-group-toggle row">
                        <div
                            class="col-4"
                            v-for="(option,
                            value) in dropDownOptions.travelOptions"
                            :key="value"
                        >
                            <label
                                class="btn radio-btn"
                                v-bind:class="{
                                    active: value === company.travel
                                }"
                            >
                                <img
                                    v-if="company.travel == value"
                                    v-bind:src="
                                        '/images/icon-checked-white.svg'
                                    "
                                    alt
                                />
                                <input
                                    type="radio"
                                    name="travel"
                                    :value="value"
                                    v-model="company.travel"
                                />
                                <span class="radio-align">{{ option }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 mb-3">
                <!-- visitors -->
                <div class="form-group">
                    <label>Do you allow visitors to your office?</label>
                    <br />
                    <div class="btn-group btn-group-toggle row">
                        <div
                            class="col-4"
                            v-for="(option,
                            value) in dropDownOptions.visitorOptions"
                            :key="value"
                        >
                            <label
                                class="btn radio-btn"
                                v-bind:class="{
                                    active: value === company.visitors
                                }"
                            >
                                <img
                                    v-if="company.visitors == value"
                                    v-bind:src="
                                        '/images/icon-checked-white.svg'
                                    "
                                    alt
                                />
                                <input
                                    type="radio"
                                    name="visitor"
                                    :id="value"
                                    v-model="company.visitors"
                                    :value="value"
                                />
                                <span class="radio-align">{{ option }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-12 mb-3">
                <div class="form-group">
                    <label>Do you still host/attend events?</label>
                    <br />
                    <div class="btn-group btn-group-toggle row">
                        <div
                            class="col-4"
                            v-for="(option,
                            value) in dropDownOptions.eventsOptions"
                            :key="value"
                        >
                            <label
                                class="btn radio-btn"
                                v-bind:class="{
                                    active: value === company.events
                                }"
                            >
                                <img
                                    v-if="company.events == value"
                                    v-bind:src="
                                        '/images/icon-checked-white.svg'
                                    "
                                    alt
                                />
                                <input
                                    type="radio"
                                    name="event"
                                    :id="value"
                                    v-model="company.events"
                                    :value="value"
                                />
                                <span class="radio-align">{{ option }}</span>
                            </label>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-md-12 mb-3">
                <div class="form-group">
                    <label for="otherRemarks"
                        >What other measures do you take?</label
                    >
                    <textarea
                        name="other_remarks"
                        id="otherRemarks"
                        cols="30"
                        rows="5"
                        class="form-control"
                        placeholder="Free masks, body heat detectors, etc."
                        v-model="company.other_remarks"
                    ></textarea>
                </div>
            </div>
        </div>

        <div class="col-12 col-md-6 mb-3">
            <div class="form-group">
                <label style="color: #000;">Check-in With Photo</label>
                <label class="font-weight-light d-flex align-items-center"
                       style="cursor: pointer">
                    <button
                        class="task-checkbox btn p-0 m-2 border-0 d-flex align-self-center shadow-none"
                        style="opacity: 100%;padding:0 !important;background-color: #F2F2F2;width: 24px;height: 24px;"
                        @click="company.photo_checkin = !company.photo_checkin"
                    >
                        <img :src="'/images/checkbox_checked.png'" v-if="company.photo_checkin"/>
                    </button>
                    Set as default check-in method</label>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-md-6 col-12 text-center">
                <div class="form-group">
                    <button
                        class="btn btn-block"
                        @click="saveChanges()"
                        :disabled="loading"
                    >
                        <span
                            class="spinner-border"
                            role="status"
                            v-show="loading"
                        >
                            <span class="sr-only">Loading...</span>
                        </span>
                        Save changes
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DropDownOptions from "../DropdownOptionsConfig";
import DropdownOptionsConfig from "../DropdownOptionsConfig";
import CompanyState from "../NewCompanyState";
import OfficeStore from "../../Offices/OfficeStore";
import ImageCompressor from '../../../ImageCompressor'

export default {
    data() {
        return {
            companyState: CompanyState,
            company: CompanyState.company,
            cities: [],
            countries: [],
            dropDownOptions: DropDownOptions,
            loading: false,
            officeStore: OfficeStore
        };
    },

    watch: {
        "company.country"() {
            this.getCities();
        }
    },

    computed: {
        isValidated() {
            const checks = [this.companyState.validateEmployeeCount()];

            return checks.length == checks.filter(check => check).length;
        },

        checkBoxIcon() {
            if (!this.completedAt) return "/images/checkbox_unchecked.png";
            return this.inputTitle
                ? "/images/checkbox_checked.png"
                : "/images/checkbox_checked_static.png";
        },

        dateText() {
            if (this.company.updated_at)
                return moment(this.company.updated_at).format("D MMMM Y");
            return moment().format("D MMMM Y");
        }
    },

    methods: {
        selectImage() {
            this.$refs.fileUpload.click();
        },

        async uploadImage(event) {
            const file = event.target.files[0]
            const imageSrc = file
            const imageName = file.name
            const fileType = file.type.split('/')[1]
            const imageBlob = window.URL.createObjectURL(imageSrc)

            this.company.logo = await ImageCompressor(imageBlob, imageName, fileType)
            this.company.logo_src = imageBlob;

            const request_params = {
                image: this.company.logo
            };

            let formData = new FormData();
            for (let key in request_params) {
                if (request_params[key]) {
                    formData.append(key, request_params[key]);
                }
            }

          await axios.post(`/company/${this.company.id}`, formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          });
        },

        async getCountries() {
          this.countries = await axios.get('/countries').then(data => data.data.data);
        },

        async getCities() {
          this.cities = await axios.get('/cities/' + this.company.country).then(data => data.data.data);
        },

        async getCurrentUserCompany() {
            const res = await axios.get("/get-user-company");
            const data = res.data.data;
            this.company.id = data.id;
            this.company.name = data.name;
            this.company.employee_count = data.employee_count;
            this.company.country = data.country;
            this.company.city = data.city;
            this.company.other_remarks = data.other_remarks;
            this.company.logo_src = data.logo_src;
            this.company.photo_checkin = data.photo_checkin;
            data.offices.map(item => {
                this.officeStore.offices.push({
                    text: item.text,
                    zone: item.zone_name,
                    isDefault: item.is_default,
                    city_id: item.city_id
                });
            });

            Object.keys(DropdownOptionsConfig.wfhOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.wfhOptions[key] ===
                    data.allow_work_from_home
                ) {
                    this.company.work_from_home = key;
                }
            });

            Object.keys(DropdownOptionsConfig.travelOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.travelOptions[key] ===
                    data.allow_travel
                ) {
                    this.company.travel = key;
                }
            });

            Object.keys(DropdownOptionsConfig.visitorOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.visitorOptions[key] ===
                    data.allow_visitors
                ) {
                    this.company.visitors = key;
                }
            });

            Object.keys(DropdownOptionsConfig.eventsOptions).forEach(key => {
                if (
                    DropdownOptionsConfig.eventsOptions[key] ===
                    data.allow_events
                ) {
                    this.company.events = key;
                }
            });
        },

        async saveChanges() {
            this.loading = true;

            const request_params = {
                name: this.company.name,
                employee_count: this.company.employee_count,
                city: this.company.city,
                country: this.company.country,
                allow_work_from_home: this.company.work_from_home,
                allow_travel: this.company.travel,
                allow_visitors: this.company.visitors,
                allow_events: this.company.events,
                other_remarks: this.company.other_remarks,
                offices: this.officeStore.preparedApiRequest(),
                photo_checkin: this.company.photo_checkin,
            };

            try {
                await axios.post(`/company/${this.company.id}`, request_params);
                location.href = "/company-profile/edit#details";
                window.scrollTo(0, 0);
                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        }
    },

    mounted() {
        this.getCountries();
        this.getCurrentUserCompany();
    }
};
</script>

<style scoped lang="scss">
.detail {
    &__image {
        margin-bottom: 40px;
    }

    .company-name {
        color: #333333;
        font-family: "Open Sans", sans-serif;
        font-size: 32px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 43px;
    }

    .member-since {
        color: #8392a6;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 24px;
    }

    .bottom {
        height: 67px;
        width: 136px;
        border-bottom-left-radius: 90px;
        border-bottom-right-radius: 90px;
        bottom: 0px;
        right: 0px;
        background-color: rgba(0, 151, 244, 0.75);
        color: #ffffff;
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        font-weight: bold;
        letter-spacing: 0;
        line-height: 17px;
        text-align: center;
        display: flex;
        justify-content: center;
        align-items: center;

        @media (max-width: 768px) {
            width: 134px;
            height: 65px;
            right: 1px;
            bottom: 1px;
        }
    }

    .middle {
        transition: 0.5s ease;
        opacity: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.41);
    }

    .form-group {
        label {
            color: #808fa4;
            font-family: "Open Sans", sans-serif;
            font-size: 14px;
            font-weight: 600;
            letter-spacing: 0.5px;
            line-height: 22px;
        }
    }

    .radio-btn {
        &.active {
            border-radius: 4px;
            background-color: #3592ff;
            color: white;
            border: none;

            .radio-align {
                margin-left: 0.5rem;
            }
        }
    }

    .radio-align {
        margin-left: 0.5rem;
        font-size: 12px !important;

        @media (max-width: 768px) {
            font-size: 10px !important;
        }
    }

    .col-6,
    .col-4 {
        @media (max-width: 768px) {
            padding-left: 10px;
            padding-right: 10px;
        }
    }

    .btn-block {
        border-radius: 6px;
        background-color: #000 !important;
        height: 56px;
        border: none;
        color: #fff;
    }

    .btn {
        background: white;
    }

    .btn-group {
        display: flex !important;
        .btn {
            input[type="radio"] {
                position: absolute;
                clip: rect(0, 0, 0, 0);
                pointer-events: none;
            }
        }
    }

    .wfh-link {
        .fas {
            color: #3592ff;
        }
    }

    .wfh-link,
    .wfh-link:hover {
        color: #303030;
        font-family: "Open Sans", sans-serif;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 22px;
        border: none;
        background-color: transparent;
        box-shadow: none;
        outline: none;
        border-radius: unset;
    }
}
.description {
    color: #9696a8;
    font-family: Montserrat;
    font-size: 14.4px;
    line-height: 18px;
    font-weight: 100;
}

.radio-btn {
    border-radius: 3px !important;
    background-color: #f2f2f2;
    height: 64px;
    margin-right: 0 !important;
    display: flex;
    align-items: center;
    color: #00002d;
    font-family: Montserrat;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    font-weight: 100;
}

.radio-btn.active {
    background-color: #fff;
    border: 2px solid #5145ff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
}

.radio-btn:last-child {
    margin-right: 0;
}

button,
button:hover,
button:disabled {
    padding: 10px 18px;
    border-radius: 6px;
    background-color: #5145ff;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
    color: #fff;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 700;
    line-height: 17px;
}

.btn {
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
}

.spinner-border {
    color: #fff;
    margin-right: 16px;
    width: 20px;
    height: 20px;
}

.modal-content {
    border: none;
}

@media (max-width: 768px) {
    .modal-dialog {
        margin: 0;
        bottom: 0;
        position: absolute;
        left: 0;
        right: 0;
    }
}
</style>
